// src/App.js

import React from 'react';
import AppRoutes from './routes';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { ConfigProvider, theme as antdTheme, App, Spin } from 'antd';
// BrowserRouter đã được xóa khỏi đây

const AppContent = () => {
  const { theme } = useTheme();
  const { loading: authLoading } = useAuth();

  if (authLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <ConfigProvider
      theme={{
        algorithm: theme === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
      }}
    >
      <AppRoutes />
    </ConfigProvider>
  );
}

function MainApp() {
  return (
    // <BrowserRouter> đã được xóa khỏi đây
    <AuthProvider>
      <ThemeProvider>
        <App>
          <AppContent />
        </App>
      </ThemeProvider>
    </AuthProvider>
    // </BrowserRouter>
  );
}

export default MainApp;